import { TabsProps } from "/Models/Generated/TabsProps";
import cn from "classnames";
import "./Tabs.scss";
import { HideFor } from "/App.Components";
import { useEffect, useState } from "react";
import OptionPicker from "../OptionPicker/OptionPicker";
import { stringsToReactSelectItems } from "/Helpers/ReactSelectItem";

interface TabsPropsExtended extends TabsProps {
  onTabClick: (upComingSelected: boolean) => void;
}

const Tabs = ({
  upcomingEventsTabSelected,
  upcomingEventsLabel,
  upcomingEventsAriaLabel,
  pastEventsLabel,
  pastEventsAriaLabel,
  dropdownGuid,
  showEventsText,
  onTabClick,
}: TabsPropsExtended) => {
  const [activeItem, setActiveItem] = useState<string | undefined>(
    upcomingEventsTabSelected ? upcomingEventsLabel : pastEventsLabel,
  );

  useEffect(() => {
    setActiveItem(
      upcomingEventsTabSelected ? upcomingEventsLabel : pastEventsLabel,
    );
  }, [upcomingEventsTabSelected]);

  const optionPickerItems =
    upcomingEventsLabel &&
    pastEventsLabel &&
    stringsToReactSelectItems([upcomingEventsLabel, pastEventsLabel]);

  const Id = dropdownGuid ?? (Math.random() + 1).toString(36).substring(7);

  return (
    <div className="tabs-norad">
      <div role="tablist" className="tabs-norad__desktop">
        {upcomingEventsLabel && pastEventsLabel && (
          <>
            <div
              className={cn("tab-norad", {
                "tab-norad--active": upcomingEventsTabSelected,
              })}
            >
              <button
                role="tab"
                aria-selected={upcomingEventsTabSelected}
                onClick={() => onTabClick(true)}
                aria-label={upcomingEventsAriaLabel}
              >
                <span>{upcomingEventsLabel}</span>
              </button>
            </div>
            <div
              className={cn("tab-norad", {
                "tab-norad--active": !upcomingEventsTabSelected,
              })}
            >
              <button
                role="tab"
                aria-selected={!upcomingEventsTabSelected}
                data-testid="upcomingTab"
                onClick={() => onTabClick(false)}
                aria-label={pastEventsAriaLabel}
              >
                <span>{pastEventsLabel}</span>
              </button>
            </div>
          </>
        )}
      </div>
      <div className="tabs-norad__mobile">
        {showEventsText && (
          <HideFor desktop>
            <p className="tabs-norad__mobile__label">{showEventsText}</p>
          </HideFor>
        )}
        {optionPickerItems && optionPickerItems.length > 0 && (
          <OptionPicker
            activeItem={
              activeItem
                ? stringsToReactSelectItems([activeItem])[0]
                : optionPickerItems[0]
            }
            items={optionPickerItems}
            dropdownId={Id}
            onOptionClick={(optionText) =>
              onTabClick(optionText === upcomingEventsLabel)
            }
          />
        )}
      </div>
    </div>
  );
};
export default Tabs;
